import authImg from "../media/authKid2.png";
import "../css/auth.css";
import google from "../media/google-Photoroom.png";
import { BouncyArc } from "ldrs/react";
import axios from "axios";
import "ldrs/react/BouncyArc.css";
import whiteLogo from "../media/whiteLogo.png";
import "../css/auth.css";
import { Icon } from "@iconify/react";
import Swal from "sweetalert2";
import { useNavigate } from "react-router";
import { auth, db } from "../firebase/firebaseConfig";
import { Helmet } from "react-helmet";
import { doc, setDoc,getDoc } from "firebase/firestore";
import {
  createUserWithEmailAndPassword,
  signInWithEmailAndPassword,
  sendEmailVerification,
  sendPasswordResetEmail,
  GoogleAuthProvider,
  signInWithPopup
} from "firebase/auth";
import "ldrs/react/Bouncy.css";
import { useEffect, useState, useRef } from "react";
export default function Auth() {
  const signEm = useRef(null);
  const signNm = useRef(null);
  const signPass = useRef(null);
  const signCpass = useRef(null);
  const logEm = useRef(null);
  const logPass = useRef(null);
  const navigate = useNavigate();
  const [logLoader, setLogLoader] = useState();
  const [signLoader, setSignLoader] = useState();
  const [logActive, setLogActive] = useState(true);

  const toSignUp = () => {
    setLogActive(false);
  };
  const toSignIn = () => {
    setLogActive(true);
  };

  const resetPass = async () => {
    const { value: email } = await Swal.fire({
      input: "email",
      text: "Enter your email address",
      inputPlaceholder: "",
    });

    if (!email) return;

    const actionCodeSettings = {
      url: "https://schoollabelskenya.com/auth",
      handleCodeInApp: false,
    };

    sendPasswordResetEmail(auth, email, actionCodeSettings)
      .then(() => {
        Swal.fire(
          "Email Sent",
          "Password reset link has been sent to your email.",
          "success",
        );
      })
      .catch((error) => {
        Swal.fire("Error", error.message, "error");
      });
  };

  const SignUp = () => {
    const fn = signNm.current.value;
    const em = signEm.current.value;
    const pass = signPass.current.value;
    const cpass = signCpass.current.value;

    if (fn && em && pass && cpass) {
      if (pass === cpass) {
        setSignLoader(true);

        createUserWithEmailAndPassword(auth, em, pass)
          .then((userCred) => {
            var user = userCred.user;
            const actionCodeSettings = {
            url: "https://schoollabelskenya.com/auth",
            handleCodeInApp: false,
          };
            sendEmailVerification(user,actionCodeSettings).then(async () => {
              const userData = {
                name: fn,
                em: em,
                uid: user.uid,
                fonReg: "",
                sexReg: "",
                photoUrl: "",
                profUpdate: false,
                cartItems: [],
              };
              await setDoc(doc(db, "Users", user.uid), userData).then(() => {
                Swal.fire(
                  "Verification Email Sent!",
                  "Check your inbox. Not there? Peek in your <strong>spam</strong> folder.",
                  "success",
                ).then(() => {
                  setSignLoader(false);
                  setLogActive(true);
                });
              });
            });
          })
          .catch((err) => {
            setSignLoader(false);
            console.log(err);

            if (err.code === "auth/email-already-in-use") {
              Swal.fire("", "Email already in use. Try logging in.", "warning");
            }
            if (err.code === "auth/invalid-email") {
              Swal.fire("", "Use a valid email", "warning");
            }
          });
      } else {
        Swal.fire("", "Your passwords dont match", "warning");
      }
    } else {
      Swal.fire("", "Oops! Looks like you missed a field", "warning");
    }
  };
  const LogIn = () => {
    const em = logEm.current.value;
    const pass = logPass.current.value;

    if (em && pass) {
      setLogLoader(true);

      signInWithEmailAndPassword(auth, em, pass)
        .then((userCred) => {
          var user = userCred.user;
          if (user.emailVerified) {
            navigate("/");
          } else {
            auth.signOut();
            Swal.fire({
              title: "Email Not Verified",
              text: "Please verify your email before signing in.",
              icon: "warning",
              confirmButtonText: "Resend Verification Email",
            }).then((result) => {
              setLogLoader(false);
              if (result.isConfirmed) {
                // Resend verification email
                sendEmailVerification(user).then(() => {
                  //  setLogLoader(true)

                  Swal.fire(
                    "Verification Email Sent!",
                    "Check your inbox. Not there? Peek in your <strong>spam</strong> folder.",
                    "success",
                  );
                });
              }
            });
          }
        })
        .catch((error) => {
          setLogLoader(false);

          var errCode = error.code;
          console.log(error);
          if (
            errCode === "auth/invalid-email" ||
            errCode === "auth/wrong-password" ||
            errCode === "auth/internal-error" ||
            errCode === "auth/invalid-credential"
          ) {
            Swal.fire("Invalid email or password", "Try again with correct credentials","error");
            setLogLoader(false);
          } else {
            Swal.fire("", "An error occured try again later", "warning");
            setLogLoader(false);

            console.log(error);
          }
        });
    } else {
      Swal.fire("", "Oops! Looks like you missed a field", "warning");
      setLogLoader(false);
    }
  };

  const ContinueWithGoogle = async () => {
  setSignLoader(true);

  const provider = new GoogleAuthProvider();

  try {
    const result = await signInWithPopup(auth, provider);
    const user = result.user;

    const userRef = doc(db, "Users", user.uid);
    const userSnap = await getDoc(userRef);

    // If user does NOT exist, create profile
    if (!userSnap.exists()) {
      const userData = {
        name: user.displayName || "",
        em: user.email,
        uid: user.uid,
        fonReg: "",
        sexReg: "",
        photoUrl: user.photoURL || "",
        profUpdate: false,
        cartItems: [],
        provider: "google",
        createdAt: Date.now(),
      };

      await setDoc(userRef, userData);
    }

    Swal.fire(
      "Welcome!",
      "You have successfully signed in with Google.",
      "success"
    ).then(() => {
      setSignLoader(false);
      navigate("/"); 
    });

  } catch (error) {
    console.error(error);
    setSignLoader(false);

    Swal.fire(
      "Google Sign-in Failed",
      "Please try again.",
      "error"
    );
  }
};

    

   useEffect(() => {
  const sendRequest = async () => {
    try {
      const response = await axios.post(
        "https://schoollabelbackend-iwy4.onrender.com/Aloo",
        {}
      );

      console.log(response.data);
    } catch (error) {
      console.log(error);
    }
  };

  sendRequest();
}, []);

  return (
    <section className="authCont">
      <Helmet>
  <title>Sign In | Your Account - Custom School Labels</title>
  <meta name="description" content="Log in to your account to access your customized school labels, manage orders, and create new designs for uniforms and stationery." />
</Helmet>
      <div className="authWrap">
        <div className="authLeft">
          <div className="authLeftCont">
            <img src={whiteLogo} alt="" />
            <span>
              Labeling solutions for everyday student {" "}
              <span className="specio">essentials.</span>
            </span>
          </div>
          <img className="authImgOver" src={authImg} alt="" />
        </div>
        <div className="authRight">
          <div className="authRightCont">
            <div className={`logWrapper ${logActive ? "authLogActive" : ""}`}>
              <div className="authSwitch">
                <p>
                  Dont have an account? <span onClick={toSignUp}>Sign Up</span>
                </p>
              </div>
              <div className={`authLog`}>
                <div className="authLogCont">
                  <h2>Sign In</h2>
                  <p>Log in to access your account.</p>
                  <div className="authInputsWrap">
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon icon="solar:letter-linear" className="faIcon" />
                        </div>
                        <div className="authInput">
                          <input
                            ref={logEm}
                            type="email"
                            placeholder="Enter email"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon
                            icon="solar:lock-keyhole-line-duotone"
                            className="faIcon"
                          />
                        </div>
                        <div className="authInput">
                          <input
                            ref={logPass}
                            type="password"
                            placeholder="Your password"
                          />
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="authForget">
                    <p onClick={resetPass}>Reset Password?</p>
                  </div>
                  <div className="authBtnWrap">
                    {logLoader ? (
                      <BouncyArc
                        size="60"
                        speed="1"
                        color="#25A9E1"
                      ></BouncyArc>
                    ) : (
                      <button onClick={LogIn}>Log In</button>
                    )}
                  </div>
                  <div className="contWithGoogle">
                    <div className="googleTop">
                      <div className="kaline"></div>
                      <span>OR</span>
                      <div className="kaline"></div>
                    </div>
                    <div className="googleBtm" onClick={ContinueWithGoogle}>
                      <img src={google} alt="" />
                      <p>Continue with Google</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`signWrapper ${logActive ? "" : "authSignActive"}`}>
              <div className="authSwitch">
                <p>
                  Already have an account?{" "}
                  <span onClick={toSignIn}>Sign In</span>
                </p>
              </div>
              <div className={`authSign `}>
                <div className="authLogCont">
                  <h2>Sign Up</h2>
                  <p>Create account to get started.</p>
                  <div className="authInputsWrap">
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon
                            icon="solar:user-rounded-line-duotone"
                            className="faIcon"
                          />

                        </div>
                        <div className="authInput">
                          <input ref={signNm} type="text" placeholder="Your full name" />
                        </div>
                      </div>
                    </div>
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon
                            icon="solar:letter-line-duotone"
                            className="faIcon"
                          />
                        </div>
                        <div className="authInput">
                          <input ref={signEm} type="email" placeholder="Enter email" />
                        </div>
                      </div>
                    </div>
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon
                            icon="solar:lock-keyhole-line-duotone"
                            className="faIcon"
                          />
                        </div>
                        <div className="authInput">
                          <input ref={signPass} type="password" placeholder="Your password" />
                        </div>
                      </div>
                    </div>
                    <div className="authInputWrap">
                      <div className="authInputWrapCont">
                        <div className="authIcon">
                          <Icon
                            icon="solar:lock-keyhole-line-duotone"
                            className="faIcon"
                          />
                        </div>
                        <div className="authInput">
                          <input
                          ref={signCpass}
                            type="password"
                            placeholder="Confirm password"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="authBtnWrap">
                    {signLoader ? (
                      <BouncyArc
                        size="60"
                        speed="1"
                        color="#25A9E1"
                      ></BouncyArc>
                    ) : (
                      <button onClick={SignUp}>Sign Up</button>
                    )}{" "}
                  </div>
                  <div className="contWithGoogle">
                    <div className="googleTop">
                      <div className="kaline"></div>
                      <span>OR</span>
                      <div className="kaline"></div>
                    </div>
                    <div className="googleBtm" onClick={ContinueWithGoogle}>
                      <img src={google} alt="" />
                      <p>Continue with Google</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
